import React from 'react';
import {LandingPageContent} from '@/constants';
import {Icon} from '@/ui-kits';
interface AboutProps {
  id?: string;
}
export const About: React.FC<AboutProps> = ({id}) => {
  return (
    <div id={id} className="flex flex-col items-center pt-0 md:pt-2 pb-6 md:pb-8 mt-4 md:-mt-6">
      <h2
        id="gradient-text-2"
        className="items-center md:py-10 text-3xl md:text-4xl lg:text-5xl font-FigtreeBold text-center mb-4 md:mb-0">
        {LandingPageContent.about.title}
      </h2>

      <div className="max-w-[1920px] w-full px-2 sm:px-4 md:px-8 lg:px-12 xl:px-16 self-center flex flex-col lg:flex-row gap-9 lg:gap-12 justify-center items-center lg:items-stretch">
        {LandingPageContent.about.cards.map((item) => (
          <div
            key={item.title}
            style={{boxShadow: '0px 7px 12px 0px rgba(0, 0, 0, 0.25)'}}
            className="flex flex-col  gap-2 4xl:px-20 lg:gap-5 min-w-0 max-w-[380px] sm:max-w-full lg:max-w-[540px] 2xl:max-w-full w-full p-4 sm:p-6 rounded-[32px]">
            <h3
              id="gradient-text-2"
              className="text-xl sm:text-xl md:text-2xl lg:text-3xl text-wrap font-PoppinsBold mb-4 text-ui_blue break-words">
              {item.title}
            </h3>
            {item.points.map((point) => (
              <div key={point.text+point.icon} className="flex max-w-full items-start gap-2 sm:gap-3 min-w-0">
                <Icon type={point.icon} className='w-[20px] sm:w-[24px] object-contain h-[20px] sm:h-[24px] flex-shrink-0'/>
                <span
                  key={point.text}
                  className="text-sm sm:text-sm lg:text-base xl:text-xl text-wrap font-FigtreeMeduim text-ui_blue break-words min-w-0">
                  {point.text}
                </span>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
